import { Button } from "@/components/catalyst/button";
import { DialogComponent } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { AlertDialog } from "@/lib/Components/Dialog/AlertDialog";
import {
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "@/components/catalyst/alert";

export const ConfirmCloseDialog: DialogComponent<
  { onConfirm?: () => void },
  boolean
> = ({ onConfirm }) => {
  const { close, reject, resolve } = useDialogState<boolean>();

  return (
    <AlertDialog>
      <AlertTitle>Unsaved changes</AlertTitle>
      <AlertDescription>
        You have unsaved changes. Are you sure you want to close without saving?
      </AlertDescription>
      <AlertActions>
        <Button
          outline
          onClick={() => {
            close();
            reject?.(false);
          }}
        >
          Cancel
        </Button>
        <Button
          color="amber"
          onClick={async () => {
            await close();
            resolve?.(true);
            onConfirm?.();
          }}
        >
          Discard changes
        </Button>
      </AlertActions>
    </AlertDialog>
  );
};
